<template>
    <div
        class="thumbnail"
        v-bind:class="{ loaded: loaded, active: active }"
        v-show="visible"
        v-on:click="showFrame()"
    >
        <img class="thumbnail-image" v-bind:data-size="size" ref="image" />
    </div>
</template>

<style scoped>
.thumbnail {
    cursor: pointer;
    display: inline-block;
    height: 75px;
    margin: 0px 20px 0px 20px;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
    width: 75px;
}

.thumbnail.loaded {
    opacity: 0.3;
}

.thumbnail.active {
    opacity: 1;
}

.thumbnail .thumbnail-image {
    height: 100%;
    width: 100%;
}
</style>

<script>
export const Thumbnail = {
    name: "thumbnail",
    props: {
        frame: {
            type: String,
            required: true
        },
        size: {
            type: String,
            required: true
        }
    },
    data: function() {
        return {
            loaded: false,
            image: null
        };
    },
    computed: {
        key: function() {
            return [
                this.$store.state.brand,
                this.$store.state.model,
                this.$store.state.productId,
                this.frame
            ].join(":");
        },
        active: function() {
            return this.frame === this.$store.state.currentFrame;
        },
        visible: function() {
            const frameP = this.frame.split("-", 2);
            let [face, index] = frameP.length > 1 ? frameP : [frameP, "0"];
            index = parseInt(index);
            if (!this.$store.state.config) return false;
            if (!this.$store.state.config.faces_m) return false;
            if (!this.$store.state.config.faces_m[face]) return false;
            if (this.$store.state.config.faces_m[face].frames - 1 < index) return false;
            return true;
        }
    },
    mounted: function() {
        this.image = this.$ripe.bindImage(this.$refs.image, {
            frame: this.frame
        });
        this.image.bind("loaded", () => (this.loaded = true));
    },
    destroyed: async function() {
        if (this.image) await this.$ripe.unbindImage(this.image);
        this.image = null;
    },
    methods: {
        showFrame() {
            this.$bus.trigger("show_frame", this.frame);
        }
    }
};

export default Thumbnail;
</script>
